<template>
  <ContentBanner
    :variant="bannerConfig.variant"
    :icon="bannerConfig.icon"
    :title="bannerConfig.title"
    primary-label="Create"
  >
    <p class="text-body-3 text-textLight mb-0">
      This employee has no completed acknowledgements on file.
    </p>
    <template #actions>
      <HideRbac :permissions="['createEmployeeJobProfileAcknowledgements']">
        <DpplDarkTooltip
          v-if="!isActionEnabled"
          tooltip-placement="bottom"
          light-mode
        >
          <template #activator="{ onMouseenter, onMouseleave }">
            <span
              class="banner-action-disabled-wrapper"
              @mouseenter="onMouseenter"
              @mouseleave="onMouseleave"
            >
              <v-btn
                color="brandPrimary"
                variant="flat"
                size="small"
                disabled
              >
                Create Acknowledgement
              </v-btn>
            </span>
          </template>
          <template #tooltip-content>
            <p class="text-body-2 text-textDark">
              {{ disabledTooltip }}
            </p>
          </template>
        </DpplDarkTooltip>
        <v-btn
          v-else
          color="brandPrimary"
          variant="flat"
          size="small"
          @click="handleCreateClick"
        >
          Create Acknowledgement
        </v-btn>
      </HideRbac>
    </template>
  </ContentBanner>
</template>

<script setup>
import ContentBanner from '@/components/library/ContentBanner.vue';
import DpplDarkTooltip from '@/components/datapeople/DpplDarkTooltip.vue';
import HideRbac from '@/components/rbac/HideRbac.vue';
import { useTracking } from '@/stores/tracking/tracking';
import { ACKNOWLEDGEMENT_PREVIEW_BANNER_CONFIG } from '@/helpers/acknowledgementAlerts';

const bannerConfig = ACKNOWLEDGEMENT_PREVIEW_BANNER_CONFIG.no_acknowledgement;

defineProps({
  isActionEnabled: { type: Boolean, default: true },
  disabledTooltip: { type: String, default: '' },
});

const emit = defineEmits(['create']);

const handleCreateClick = () => {
  useTracking().ackLibClickedCreate({ location: 'In Sidebar Alert window' });

  emit('create');
};
</script>

<style scoped lang="less">
.banner-action-disabled-wrapper {
  display: inline-block;
}
</style>
